import h from 'hyperscript';
import iconWarningSmall from '@disy/cadenza-icons/warning.svg';

import { icon } from 'cadenza/utils/icon/icon';
import { commonI18n } from 'cadenza/utils/i18n/i18n';
import {
  getLayerTasks,
  LAYER_EVENT_ALL_TASKS_COMPLETED,
  LAYER_EVENT_TASKS_CANCELED,
  LAYER_EVENT_TASKS_ONGOING
} from 'cadenza/map/layer-tasks';

import './legend-layer-tasks.css';
import i18n from './legend-layer-tasks.properties';

const NAME = 'd-layer-tasks';
const TASK_INFO_DELAY_IN_MS = 500;

export class LegendLayerTasks extends HTMLElement {

  #layer;
  #layerTasks;
  #canceled = false;
  #taskUi;
  #longRunningTimeoutId;

  constructor (layer) {
    super();
    this.#layer = layer;
    this.#layerTasks = getLayerTasks(layer);

    this.#layer.on(LAYER_EVENT_TASKS_ONGOING, () => {
      if (this.#taskUi && this.#taskUi.parentElement) {
        this.#taskUi.remove();
      }
      this.#taskUi = this._createRunningUi();
      this.append(this.#taskUi);
      this.#longRunningTimeoutId = setTimeout(
        () => this.#taskUi.classList.add(
          'is-long-running', '.d-alert', 'd-alert-small', 'd-alert-warning'
        ),
        TASK_INFO_DELAY_IN_MS);
    });

    this.#layer.on(LAYER_EVENT_ALL_TASKS_COMPLETED, () => {
      clearTimeout(this.#longRunningTimeoutId);
      if (this.#taskUi) {
        this.#taskUi.remove();
      }
    });

    this.#layer.on(LAYER_EVENT_TASKS_CANCELED, () => {
      if (this.#taskUi) {
        this.#taskUi.remove();
      }
      if (this.#layerTasks.hasRestartableTasks()) {
        this.#taskUi = this._createCancelledUi();
        this.append(this.#taskUi);
      }
    });
  }

  cloneNode () {
    const cloned = new LegendLayerTasks(this.#layer);
    cloned.connectedCallback();
    const clonedChildren = [ ...this.children ].map(el => el.cloneNode(true));
    clonedChildren.forEach(el => {
      cloned.appendChild(el);
    });
    cloned.#taskUi = this._createRunningUi();
    cloned.append(this.#taskUi);
    return cloned;
  }

  connectedCallback () {
    this.classList.add(NAME);
  }

  _createRunningUi () {
    return h('.d-layer-task.d-layer-task-running', [
      h('d-progress-spinner.d-progress-spinner-xs.d-progress-spinner-gray'),
      h('span.d-layer-task--text.ellipsis', i18n('fetchingData')),
      h('button.d-anchor',
        { onclick: this._onCancel.bind(this) },
        commonI18n('cancel'))
    ]);
  }

  _createCancelledUi () {
    return h('.d-layer-task.d-alert.d-alert-small.d-alert-warning', [
      icon(iconWarningSmall),
      h('span.d-layer-task--text.ellipsis', i18n('canceled')),
      h('button.d-anchor',
        { onclick: this._onRestart.bind(this) },
        i18n('restart'))
    ]);
  }

  _onCancel (event) {
    clearTimeout(this.#longRunningTimeoutId);
    this.#layerTasks.cancelTasks();
    this.#canceled = true;
    event.stopPropagation();
  }

  _onRestart (event) {
    this.#taskUi.remove();
    this.#layerTasks.restartTasks();
    event.stopPropagation();
  }

}

customElements.define(NAME, LegendLayerTasks);
